import { mapActions, mapGetters, mapMutations } from "vuex";
import { required, email } from 'vuelidate/lib/validators';
import {validationMixin} from "vuelidate";
import {
    SEND_ASK
} from "@/store/action-types";
import {
    POPUP_TEXT_CONTENT,
    SHOW_POPUP_TEXT_CONTENT
} from "@/store/mutation-types";


export default {
    name: 'faq-feedback',
    mixins: [validationMixin],
    data(){
        return {
            name: '',
            email: '',
            message: '',
            validationErrors: {},
        }
    },
    validations: {
        name: {
            required,
        },
        email: {
            required,
            email
        },
        message: {
            required,
        },
    },
    computed: {
        ...mapGetters({
            loading: 'faq/loadingAsk'
        }),
        nameErrors() {
            let error = [];
            if (!this.$v.name.$dirty) {
                return error;
            }
            if (!this.$v.name.required) {
                error.push(this.$t('validationRequired'));
            }
            if (this.validationErrors.name) {
                this.validationErrors.name.forEach((row) => {
                    error.push(row);
                });
            }
            return error;
        },
        emailErrors() {
            let error = [];
            if (!this.$v.email.$dirty) {
                return error;
            }
            if (!this.$v.email.required) {
                error.push(this.$t('validationRequired'));
            }
            if (!this.$v.email.email) {
                error.push(this.$t('validationEmail'));
            }
            if (this.validationErrors.email) {
                this.validationErrors.email.forEach((row) => {
                    error.push(row);
                });
            }

            return error;
        },
        messageErrors() {
            let error = [];
            if (!this.$v.message.$dirty) {
                return error;
            }
            if (!this.$v.message.required) {
                error.push(this.$t('validationRequired'));
            }
            if (this.validationErrors.message) {
                this.validationErrors.message.forEach((row) => {
                    error.push(row);
                });
            }
            return error;
        },
    },
    methods: {
        ...mapActions({
           send: `faq/${SEND_ASK}`
        }),
        ...mapMutations({
            changeContent: `system/${POPUP_TEXT_CONTENT}`,
            showPopup: `system/${SHOW_POPUP_TEXT_CONTENT}`,
        }),
        resetForm(){
            this.$v.$reset();
            this.email = '';
            this.name = '';
            this.message = '';
        },
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                let obj = {
                    email: this.email,
                    name: this.name,
                    message: this.message,
                };
                this.send(obj)
                    .then(() => {
                        this.resetForm();
                        this.changeContent({
                            title: 'Сообщение успешно отправлено отправлено',
                            text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Delectus distinctio dolores impedit itaque labore mollitia, repudiandae saepe tempore vel voluptatibus? Alias doloribus error excepturi id in inventore, mollitia quas ut.'
                        });
                        this.showPopup(true);
                    }).catch(error => {
                    if(error.response.status === 422){
                        this.validationErrors = error.response.data.errors;
                    }
                });
            }
        },
    }

}
